import { useStore } from '@tanstack/react-form';
import { useFieldContext } from '.';
import { FieldErrors } from './FieldErrors';
import LanguageChipInput from '../LanguageChipInput';

export const LanguageField = () => {
  const field = useFieldContext<string[]>();
  const hasTriedToSubmit = useStore(
    field.form.store,
    (state) => state.submissionAttempts > 0
  );
  const shouldShowError = field.state.meta.isTouched || hasTriedToSubmit;
  const error = shouldShowError ? field.state.meta.errors.length > 0 : false;
  return (
    <LanguageChipInput
      selectedLanguages={field.state.value}
      onChange={(languages) => {
        field.handleChange(languages.map((language) => language.key));
      }}
      meta={{
        error: error ? <FieldErrors meta={field.state.meta} /> : undefined,
        touched: shouldShowError,
      }}
    />
  );
};
